<template>
  <div>
    <form-tan v-model="data" @next="nextHandler"  />
  </div>
</template>

<script>
import FormTan from "../components/FormTan";
import ModParticipant from "../modules/ModParticipant";

export default {
  name: "ViewTan",
  components: {
    FormTan,
  },
  data() {
    return {
      data: ModParticipant.data,
    };
  },
  methods: {
    nextHandler() {
      this.$specs.registrationNeeded
        ? this.$router.push("/register")
        : this.$router.push("/vip");
    },
  },
};
</script>